<script>
	import Router from '../../States/Router';
	export let timeline = [];

	function getIcon(type) {
		return type == 'incoming' ? 'uil-incoming-call' : 'uil-outgoing-call';
	}

	function getColor(type) {
		return type == 'unanswered' ? 'danger' : 'success';
	}

	function goToConference(conferenceId, contactId) {
		Router.component('conference', {id: conferenceId, contactId, show: true});
	}
</script>

<style>
	.timeline-item-info > div {
		text-transform: capitalize;
	}

	.timeline-item-info {
		cursor: pointer;
	}
</style>

<div class="card">
	<div class="card-body">
		<h4 class="header-title mb-3">Contact Timeline</h4>
		<div data-simplebar="" style="max-height:600px">
			<div class="timeline-alt pb-0">
				{#each timeline as item}
					<div class="timeline-item">
						<i class="uil {getIcon(item.type)} bg-{getColor(item.type)}-lighten text-{getColor(item.type)} timeline-icon"></i>
						<div class="timeline-item-info" on:click={() => goToConference(item.conferenceId, item.contactId)}>
							<div class="text-{getColor(item.type)} fw-bold mb-1 d-block">{item.title}</div>
							<small>{item.description}</small>
							<p class="mb-0 pb-2">
								<small class="text-muted">{item.dateTime}</small>
							</p>
						</div>
					</div>
				{/each}
			</div>
		</div>
	</div>
</div>
